import { render, staticRenderFns } from "./commissionCharge.vue?vue&type=template&id=202e5474&"
import script from "./commissionCharge.vue?vue&type=script&lang=js&"
export * from "./commissionCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports